import React, {
  useState,
  useEffect,
  useRef,
} from 'react';
import Card from 'react-credit-cards';
import { formatCreditCardNumber, formatCVC, formatExpirationDate } from './utils';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import 'react-credit-cards/es/styles-compiled.css';
import styles from './form.css'
import { withStyles } from "@material-ui/core";
import SpinLoader from '../../util/SpinLoader';
import { messages } from "../../agent-panel/sessions/constants";
import { compose } from "../../utility";
import withFade from "../../account/shared/animationHOC";
import { withSnackbar } from "../../shared/snackbar";
import { withAppUser } from "../../shared/authorization";
import { withRouter } from "react-router-dom";
import Swal from 'sweetalert2'
import {alphaNumericOnly} from '../../utility';
import useRequest from '../../util/RequestEsign';


const PaymentForm = (props) => {
  const { history, user, firstName, createSnackbar } = props;
  const formRef = useRef(null);

  const [number, setNumber] = useState('');
  const [name, setName] = useState(firstName || '');
  const [expiry, setExpiry] = useState('');
  const [cvc, setCvc] = useState('');
  const [issuer, setIssuer] = useState('');
  const [focused, setFocused] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fullName = `${user.firstName} ${user.lastName}`;
    if (fullName) {
      setName(fullName);
    }
  }, [user.firstName, user.lastName]);

  const handleCallback = ({ issuer: detectedIssuer }, isValid) => {
    if (isValid) {
      setIssuer(detectedIssuer);
    }
  };

  const handleInputFocus = ({ target }) => {
    setFocused(target.name);
  };

  const handleInputChange = (event) => {
    const { target } = event;
    const { value } = target;
    if (target.name === 'number') {
      const formattedValue = formatCreditCardNumber(value);
      setNumber(formattedValue);
    } else if (target.name === 'expiry') {
      const formattedValue = formatExpirationDate(value);
      setExpiry(formattedValue);      
    } else if (target.name === 'cvc') {
      const formattedValue = formatCVC(value);
      setCvc(formattedValue);
    } else if (target.name === 'name') {
      setName(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get('status');
    const method = status === 'replace' ? 'PATCH' : 'POST';

    // Show Loader
    setLoading(true);

    const formData = [...e.target.elements]
      .filter(d => d.name)
      .reduce((acc, d) => {
        acc[d.name] = d.value;
        return acc;
      }, {});

    try {
      const dates = formData.expiry.split('/');

      let body = {
        Number: formData.number,
        ExpireMonth: dates[0],
        ExpireYear: `20${dates[1]}`,
        CVV: formData.cvc,
      };

      if (method === 'POST') {
        body = {
          firstName: alphaNumericOnly(user.firstName),
          lastName: alphaNumericOnly(user.lastName),
          email: user.email,
          CreditCardInformation: body,
        };
      }

      const addCard = await useRequest({
        endPoint: '/card',
        responseFormat: 'raw',
        method,
        body,
      });

      if (addCard.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Credit Card Successfully Added!',
          toast: true,
          showConfirmButton: false,
          timer: 1500,
        }).then(() => history.push('/payment/setting'));

        return;
      }

      throw new Error('Transaction was not succesful');
    } catch (error) {
      setLoading(false);
      createSnackbar(messages.GET_CC_ERROR, { timer: 5000 });
    }
  };

  const onBack = () => {
    history.push('/payment/setting');
  };

  
  return (
    <div key="Payment" className="payment-info-container">
      <div className="App-payment">
        <div className="credit-card-visual">
          <Card
            number={number}
            name={name}
            expiry={expiry}
            cvc={cvc}
            focused={focused}
            callback={handleCallback}
          />
        </div>
        <br />

        {loading && <SpinLoader />}
        {!loading && (
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="form-group">
              <TextField
                type="tel"
                fullWidth
                label="Card Number"
                name="number"
                value={number}
                className="form-control"
                pattern="[\d| ]{16,22}"
                required
                onChange={handleInputChange}
                onFocus={handleInputFocus}
              />

            </div>
            <div className="form-group">
              <TextField
                type="text"
                name="name"
                fullWidth
                className="form-control"
                label="Name"
                required
                onChange={handleInputChange}
                onFocus={handleInputFocus}
                value={name}
              />
            </div>
            <div className="row">
              <div className="col-12">
                <TextField
                  type="tel"
                  name="expiry"
                  className="form-control"
                  label="Expiration (MM/YY)"
                  pattern="\d\d/\d\d"
                  required
                  size="small"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  value={expiry}
                  maxLength={5}
                />
                <TextField
                  type="tel"
                  name="cvc"
                  className="form-control"
                  label="CVC"
                  pattern="\d{3,4}"
                  required
                  size="small"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  value={cvc}
                  maxLength={4}
                />
              </div>
            </div>
            <input type="hidden" name="issuer" value={issuer} />
            <br />
            <div className="form-actions">
              <Button
                type="submit"
                className="btn btn-primary submit-button"
                variant="contained"
              >Add Credit Card
              </Button>

              <Button
                onClick={onBack}
                className="btn btn-default submit-button"
                variant="contained"
              >Back
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};



export default compose(
  withFade,
  withSnackbar,
  withAppUser,
  withRouter,
  withStyles(styles, { withTheme: true })
)(PaymentForm);